<template>
  <scroll-area>
    <template slot="header">

      <v-layout v-if="getFields && !getData.$id" column px-1>
        <v-layout shrink v-if="model.fields.name" px-0>

          <v-flex xs5 shrink px-0 pb-2>
          
            <v-text-field
              light
              auto-grow        
              single-line
              flat
              readonly
              disabled
              class="white pl-2"
              persistent-hint
              hide-details
              height="44"
              :label="$t('name')"
              :rows="1"
              color="grey"
            >
          
            </v-text-field>

          </v-flex>

          <v-flex xs7 shrink px-0 pb-2>
                  
            <v-text-field
              :data-testid="$options.name + '__text-field__' + 'name'"
              v-model="model.obj.name"
              light
              auto-grow
              :rules="model.fields.name && model.fields.name.required ? [value => !!value || $t('required')] : []"
              validate-on-blur       
              single-line
              flat
              class="white"
              persistent-hint
              hide-details
              height="44"
              :rows="1"
              color="accent"
            >
          
            </v-text-field>

          </v-flex>

        </v-layout>

      </v-layout>

    </template>

    <template slot="body">

        <v-form ref="device-form" style="height: 100%">

          <v-layout column fill-height justify-start>
              
              <v-flex v-if="getData && !getData.$id"  ma-0 pa-1 >
                <v-layout shrink justify-start class="white" pa-2>
                  <span class="caption font-weight-medium font-condensend">{{ $t('template') }}</span>
                </v-layout>
                <json-viewer 
                  :value="getData"
                  :expand-depth="5"
                ></json-viewer>
              </v-flex>

              <v-container fluid v-if="getData.$id" class="white" py-0 px-1>

                <v-layout column fill-height v-if="getFields" justify-start pt-0>

                  <v-flex shrink v-show="getPlaces[panel] == 'main'" mt-1>

                    <v-flex xs12>

                      <v-layout row v-if="getFields" justify-space-between align-center class="white" >

                        <v-flex xs12 v-for="(field, name) in getFields" :key="name" v-if="field.show == 'true' && field.type == 'timestamp'">

                          <date-picker
                            :value="model.obj[field.name]"
                            :label="field.name"
                            @dateChange="(payload) => {onDateChange(payload, field.name)}"
                          />

                        </v-flex>

                      </v-layout>

                    </v-flex>

                  </v-flex>

                  <v-layout row justify-start align-start ma-0>

                    <v-flex xs6 pt-0>

                      <v-layout column fill-height v-if="getFields && getPlaces[panel] == 'main'" ma-0>

                        <v-flex v-for="(field, name) in getFields" :key="name" v-show="field.show == 'true' && (field.type == 'text' || field.type == 'integer') && field.place == 'main' && field.name != 'position'" pt-1>

                          <v-flex v-if="!field.fields" shrink px-0 >

                            <v-layout shrink px-2>

                              <v-flex xs5 shrink px-0 pb-2>
                                
                                <v-text-field
                                  light
                                  auto-grow
                                  single-line
                                  flat
                                  readonly
                                  disabled
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :label="$t(field.name)"
                                  :rows="1"
                                  color="grey"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs7 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-if="field.type == 'integer'"
                                  :data-testid="$options.name + '__text-field__' + field.name"
                                  v-model.number="model.obj[field.name]"
                                  :type="'number'"
                                  light
                                  auto-grow
                                  :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                  single-line
                                  flat
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                                <v-text-field
                                  v-else
                                  :data-testid="$options.name + '__text-field__' + field.name"
                                  v-model="model.obj[field.name]"
                                  light
                                  auto-grow
                                  :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                  single-line
                                  flat
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                          </v-flex>

                          <v-flex v-if="field.fields" shrink px-0 >

                            <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'main' && sfield.name != 'name'" pt-1>

                              <v-layout shrink v-if="sfield.type == 'text' || sfield.type == 'integer'" px-2>

                                <v-flex xs5 shrink px-0 pb-2>
                                  
                                  <v-text-field
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    readonly
                                    disabled
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :label="$t(sfield.name)"
                                    :rows="1"
                                    color="grey"
                                  >

                                  </v-text-field>

                                </v-flex>

                                <v-flex xs7 shrink px-0 pb-2>
                                        
                                  <v-text-field
                                    v-if="sfield.type == 'integer'"
                                    :data-testid="$options.name + '__text-field__' + sfield.name"
                                    v-model.number="model.obj[field.name][sfield.name]"
                                    :type="'number'"
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >

                                  </v-text-field>

                                  <v-text-field
                                    v-else
                                    :data-testid="$options.name + '__text-field__' + sfield.name"
                                    v-model="model.obj[field.name][sfield.name]"
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >

                                  </v-text-field>

                                </v-flex>

                              </v-layout>

                              <v-checkbox v-if="sfield.type == 'boolean'" small light color="secondary" 
                                :data-testid="$options.name + '__checkbox__' + field.name + sfield.name"
                                v-model="model.obj[field.name][sfield.name]">
                                <template v-slot:label>
                                  <span class="black--text">{{$t(sfield.name)}}</span>
                                </template>
                              </v-checkbox>

                            </v-flex>

                          </v-flex>

                        </v-flex>

                        <v-flex xs12 v-for="(field, name) in getFields" :key="'boolean' + name" v-if="field.show == 'true' && field.type == 'boolean' && field.place == 'main'" pl-2>

                          <v-checkbox small light color="secondary" 
                            :data-testid="$options.name + '__checkbox__' + field.name"
                            v-model="model.obj[field.name]">
                            <template v-slot:label>
                              <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                              <span class="black--text" v-else>{{$t(field.name)}}</span>
                            </template>
                          </v-checkbox>

                        </v-flex>

                      </v-layout>

                      <v-layout column fill-height v-if="getFields && getPlaces[panel] == 'config'" ma-0>

                        <v-expansion-panel
                          light
                        >

                        <v-expansion-panel-content expand-icon="" style="background-color: white; border: solid 1px #EBEBEB">
                          <template v-slot:header>
                            <v-layout justify-start align-center 
                              :data-testid="$options.name + '__expansion-panel-content__' + 'ping'"
                              @click="() => exPanelClick('ping')">
                              <v-icon :style="exPanel == 'ping' ? 'transform: rotate(-180deg);' : ''">expand_more</v-icon>
                              <v-flex shrink px-3>
                                <span class="body-2 text-uppercase">{{$t('ping')}}</span>
                              </v-flex>
                            </v-layout>
                          </template>
                          <v-card  style="max-height: 100%">

                            <v-flex v-for="(field, name) in getFields" :key="'ping_' + name">

                              <v-layout shrink v-if="field.show == 'true' && field.group == 'ping' && field.place == 'config' && (field.type == 'text' || field.type == 'integer')"px-2>
                                <v-flex xs5 shrink px-0 pb-2>
                                  
                                  <v-text-field
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    readonly
                                    disabled
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :label="$t(field.name)"
                                    :rows="1"
                                    color="grey"
                                  >
                                
                                  </v-text-field>
            
                                </v-flex>
            
                                <v-flex xs7 shrink px-0 pb-2>
                                        
                                  <v-text-field
                                    v-if="field.type == 'integer'"
                                    :data-testid="$options.name + '__text-field__' + field.name"
                                    v-model.number="model.obj[field.name]"
                                    :type="'number'"
                                    light
                                    auto-grow
                                    single-line
                                    :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >
                                
                                  </v-text-field>
            
                                  <v-text-field
                                    v-else
                                    :data-testid="$options.name + '__text-field__' + field.name"
                                    v-model="model.obj[field.name]"
                                    light
                                    auto-grow
                                    single-line
                                    :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >
                                
                                  </v-text-field>
            
                                </v-flex>

                              </v-layout>

                              <v-flex shrink v-if="field.fields" px-0 >

                                <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'config' && sfield.name != 'name'" pa-0>

                                  <v-layout shrink v-if="sfield.group == 'ping' && (sfield.type == 'text' || sfield.type == 'integer')" px-2>

                                    <v-flex xs5 shrink px-0 pb-2>
                                      
                                      <v-text-field
                                        light
                                        auto-grow
                                        single-line
                                        flat
                                        readonly
                                        disabled
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :label="$t(sfield.name)"
                                        :rows="1"
                                        color="grey"
                                      >

                                      </v-text-field>

                                    </v-flex>

                                    <v-flex xs7 shrink px-0 pb-2>
                                            
                                      <v-text-field
                                        v-if="sfield.type == 'integer'"
                                        :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                        v-model.number="model.obj[field.name][sfield.name]"
                                        :type="'number'"
                                        light
                                        auto-grow
                                        single-line
                                        flat
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :rows="1"
                                        color="accent"
                                      >

                                      </v-text-field>
                                      <v-text-field
                                        v-else
                                        :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                        v-model="model.obj[field.name][sfield.name]"
                                        light
                                        auto-grow
                                        single-line
                                        flat
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :rows="1"
                                        color="accent"
                                      >

                                      </v-text-field>

                                    </v-flex>

                                  </v-layout>

                                  <v-flex shrink v-if="sfield.group == 'ping' && (sfield.type == 'select' || sfield.type == 'select_enum')"  pl-0 >

                                    <v-layout shrink px-2>

                                      <v-flex xs5 shrink px-0 pb-2>
                                              
                                        <v-text-field
                                          light
                                          auto-grow
                                          single-line
                                          flat
                                          readonly
                                          disabled
                                          class="white"
                                          persistent-hint
                                          hide-details
                                          :label="$t(name)"
                                          :rows="1"
                                          color="grey"
                                        >

                                        </v-text-field>

                                      </v-flex>

                                      <v-flex xs7 shrink px-0 pb-2>

                                        <v-select
                                          :data-testid="$options.name + '__select__' + field.name + sfield.name"
                                          v-model="model.obj[field.name][sfield.name]"
                                          light
                                          :items="getItems[sfield.cls]"
                                          :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                          :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                          single-line
                                          hide-details
                                          flat
                                          class="white"
                                          background-color="white"
                                          clearable
                                        >
                                          <template v-slot:item="{ item, index }">
                                              <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                          </template>
                                          <template v-slot:selection="{ item, index }">
                                              <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                          </template>
                                        </v-select>

                                      </v-flex>

                                    </v-layout>

                                  </v-flex>

                                  <v-flex shrink v-if="sfield.group == 'ping' && sfield.type == 'boolean'"  pl-2 >

                                    <v-checkbox small light color="secondary" 
                                    :data-testid="$options.name + '__checkbox__' + field.name + sfield.name"
                                    v-model="model.obj[field.name][sfield.name]">
                                      <template v-slot:label>
                                        <span class="black--text">{{$t(sfield.name)}}</span>
                                      </template>
                                    </v-checkbox>

                                  </v-flex>

                                </v-flex>

                              </v-flex>

                            </v-flex>

                            <v-flex xs12 v-if="field.place == 'config'" v-for="(field, name) in getFields" :key="'ping_boolean_' + name" pl-2>

                              <v-checkbox
                                small
                                light
                                color="secondary"
                                v-if="field.show == 'true' && field.group == 'ping' && field.type == 'boolean'"
                                :data-testid="$options.name + '__checkbox__' + field.name"
                                v-model="model.obj[field.name]"
                              >
                                <template v-slot:label>
                                  <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                                  <span class="black--text" v-else>{{$t(field.name)}}</span>
                                </template>
                              </v-checkbox>

                            </v-flex>

                          </v-card>
                        </v-expansion-panel-content>

                        </v-expansion-panel>

                        <v-expansion-panel
                          light
                          v-for="(bridge, name) in getBridges" :key="'bridge_' + name"
                        >
                          <v-expansion-panel-content expand-icon="" style="background-color: white; border: solid 1px #EBEBEB">
                              <template v-slot:header>
                                <v-layout justify-start align-center 
                                :data-testid="$options.name + '__expansion-panel-content__' + bridge"
                                @click="() => exPanelClick(bridge)">
                                  <v-icon :style="exPanel == bridge ? 'transform: rotate(-180deg);' : ''">expand_more</v-icon>
                                  <v-flex shrink px-3>
                                    <span class="body-2 text-uppercase">{{$t(bridge)}}</span>
                                  </v-flex>
                                </v-layout>
                              </template>
                            <v-card style="max-height: 100%">

                              <v-flex v-for="(field, name) in getFields" :key="bridge + '_' + name">

                                <v-flex shrink v-if="!field.fields && field.show == 'true' && field.group == bridge && (field.type == 'text' || field.type == 'integer')" px-0 >

                                  <v-layout shrink px-2>
                                    <v-flex xs5 shrink px-0 pb-2>
                                      
                                      <v-text-field
                                        light
                                        auto-grow
                                        single-line
                                        flat
                                        readonly
                                        disabled
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :label="$t(field.name)"
                                        :rows="1"
                                        color="grey"
                                      >
                                    
                                      </v-text-field>
                
                                    </v-flex>
                
                                    <v-flex xs7 shrink px-0 pb-2>
                                            
                                      <v-text-field
                                        v-if="sfield.type == 'integer'"
                                        :data-testid="$options.name + '__text-field__' + field.name"
                                        v-model.number="model.obj[field.name]"
                                        :type="'number'"
                                        light
                                        auto-grow
                                        single-line
                                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                        flat
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :rows="1"
                                        color="accent"
                                      >
                                    
                                      </v-text-field>
                                      <v-text-field
                                        v-else
                                        :data-testid="$options.name + '__text-field__' + field.name"
                                        v-model="model.obj[field.name]"
                                        light
                                        auto-grow
                                        single-line
                                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                        flat
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :rows="1"
                                        color="accent"
                                      >
                                    
                                      </v-text-field>
                
                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                                <v-flex shrink v-show="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == bridge && field.place == 'config'" pl-1 pb-1 >

                                  <v-layout shrink px-2>

                                    <v-flex xs5 v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == bridge && field.place == 'config'" shrink px-0 pb-2>
                                            
                                      <v-text-field
                                        light
                                        auto-grow
                                        single-line
                                        flat
                                        readonly
                                        disabled
                                        class="white"
                                        persistent-hint
                                        hide-details
                                        :label="$t(name)"
                                        :rows="1"
                                        color="grey"
                                      >

                                      </v-text-field>

                                    </v-flex>

                                    <v-flex xs7 v-if="(field.type == 'select' || field.type == 'select_enum') && field.show == 'true' && field.name != 'template' && field.name.substring(0, 1) != '$' && field.place == getPlaces[panel]" shrink px-0 pb-2>

                                      <v-select
                                        :data-testid="$options.name + '__select__' + field.name"
                                        v-model="model.obj[field.name]"
                                        light
                                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                        :items="getItems[field.cls]"
                                        :item-text="field.type == 'select' ? 'name' : 'value'"
                                        :item-value="field.type == 'select' ? '$id' : 'id'"
                                        single-line
                                        hide-details
                                        flat
                                        class="white"
                                        background-color="white"
                                        clearable
                                      >
                                        <template v-slot:item="{ item, index }">
                                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                        </template>
                                        <template v-slot:selection="{ item, index }">
                                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                        </template>
                                      </v-select>

                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                                <v-flex shrink v-if="field.fields" px-0 >

                                  <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'config' && sfield.name != 'name'" pa-0>

                                    <v-layout shrink v-if="sfield.group == bridge && (sfield.type == 'text' || sfield.type == 'integer')" px-2>

                                      <v-flex xs5 shrink px-0 pb-2>
                                        
                                        <v-text-field
                                          light
                                          auto-grow
                                          single-line
                                          flat
                                          readonly
                                          disabled
                                          class="white"
                                          persistent-hint
                                          hide-details
                                          :label="$t(sfield.name)"
                                          :rows="1"
                                          color="grey"
                                        >

                                        </v-text-field>

                                      </v-flex>

                                      <v-flex xs7 shrink px-0 pb-2>
                                              
                                        <v-text-field
                                          v-if="sfield.type == 'integer'"
                                          :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                          v-model.number="model.obj[field.name][sfield.name]"
                                          :type="'number'"
                                          light
                                          auto-grow
                                          single-line
                                          flat
                                          class="white"
                                          persistent-hint
                                          hide-details
                                          :rows="1"
                                          color="accent"
                                        >

                                        </v-text-field>
                                        <v-text-field
                                          v-else
                                          :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                          v-model="model.obj[field.name][sfield.name]"
                                          light
                                          auto-grow
                                          single-line
                                          flat
                                          class="white"
                                          persistent-hint
                                          hide-details
                                          :rows="1"
                                          color="accent"
                                        >

                                        </v-text-field>

                                      </v-flex>

                                    </v-layout>

                                    <v-flex shrink v-if="sfield.group == bridge && (sfield.type == 'select' || sfield.type == 'select_enum')"  pl-0 >

                                      <v-layout shrink px-2>

                                        <v-flex xs5 shrink px-0 pb-2>
                                                
                                          <v-text-field
                                            light
                                            auto-grow
                                            single-line
                                            flat
                                            readonly
                                            disabled
                                            class="white"
                                            persistent-hint
                                            hide-details
                                            :label="$t(name)"
                                            :rows="1"
                                            color="grey"
                                          >

                                          </v-text-field>

                                        </v-flex>

                                        <v-flex xs7 shrink px-0 pb-2>

                                          <v-select
                                            :data-testid="$options.name + '__select__' + field.name + sfield.name"
                                            v-model="model.obj[field.name][sfield.name]"
                                            light
                                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                            :items="getItems[sfield.cls]"
                                            :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                            :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                            single-line
                                            hide-details
                                            flat
                                            class="white"
                                            background-color="white"
                                            clearable
                                          >
                                            <template v-slot:item="{ item, index }">
                                                <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                            </template>
                                            <template v-slot:selection="{ item, index }">
                                                <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                            </template>
                                          </v-select>

                                        </v-flex>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex shrink v-if="sfield.group == bridge && sfield.type == 'boolean'"  pl-2 >

                                      <v-checkbox small light color="secondary" 
                                      :data-testid="$options.name + '__checkbox__' + field.name + sfield.name"
                                      v-model="model.obj[field.name][sfield.name]">
                                        <template v-slot:label>
                                          <span class="black--text">{{$t(sfield.name)}}</span>
                                        </template>
                                      </v-checkbox>

                                    </v-flex>

                                  </v-flex>

                                </v-flex>

                              </v-flex>

                              <v-flex xs12 v-if="!field.fields && field.place == 'config'" v-for="(field, name) in getFields" :key="bridge + '_boolean_' + name" pl-2>

                                <v-checkbox
                                  small
                                  light
                                  color="secondary"
                                  v-if="field.show == 'true' && field.group == bridge && field.type == 'boolean'"
                                  :data-testid="$options.name + '__checkbox__' + field.name"
                                  v-model="model.obj[field.name]"
                                >
                                  <template v-slot:label>
                                    <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                                    <span class="black--text" v-else>{{$t(field.name)}}</span>
                                  </template>
                                </v-checkbox>

                              </v-flex>

                            </v-card>
                          </v-expansion-panel-content>

                        </v-expansion-panel>

                      </v-layout>

                    </v-flex>

                    <v-flex xs6 grow pt-0>

                      <v-layout column fill-height v-if="getPlaces[panel] == 'main'" ma-0 pt-1>

                        <v-flex v-if="model.fields.position" pt-0 pl-1 pb-1>

                          <v-layout shrink>

                            <v-flex xs5 shrink px-0 pb-2>
                                    
                              <v-text-field
                                light
                                auto-grow
                                single-line
                                flat
                                readonly
                                disabled
                                class="white"
                                persistent-hint
                                hide-details
                                :label="model.fields.position && model.fields.position.required ? $t('unit') + ' *' : $t('unit')"
                                :rows="1"
                                color="grey"
                              >

                              </v-text-field>

                            </v-flex>

                            <v-flex xs7 shrink px-0 pb-2>

                              <v-select
                                :data-testid="$options.name + '__select__' + 'position'"
                                v-model="model.obj.position"
                                light
                                :items="getOpenUnits"
                                single-line
                                hide-details
                                flat
                                class="white"
                                background-color="white"
                                clearable
                              >
                              </v-select>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex v-if="getFields" v-for="(field, name) in getFields" :key="'main_'+ name" pa-0>

                          <v-flex shrink v-show="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.name != 'device_type' && field.name != 'dev_level' && field.place == 'main'" pl-1 pb-1 >

                            <v-layout shrink v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.name != 'device_type' && field.name != 'dev_level' && field.place == 'main'" >

                              <v-flex xs5 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  light
                                  auto-grow
                                  single-line
                                  flat
                                  readonly
                                  disabled
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :label="model.fields[field.name] && model.fields[field.name].required ? $t(name) + ' *' : $t(name)"
                                  :rows="1"
                                  color="grey"
                                >

                                </v-text-field>

                              </v-flex>

                              <v-flex xs7 shrink px-0 pb-2>

                                <v-select
                                  :data-testid="$options.name + '__select__' + field.name"
                                  v-model="model.obj[field.name]"
                                  light
                                  :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                  :items="getItems[field.cls]"
                                  :item-text="field.type == 'select' ? 'name' : 'value'"
                                  :item-value="field.type == 'select' ? '$id' : 'id'"
                                  single-line
                                  hide-details
                                  flat
                                  class="white"
                                  background-color="white"
                                  clearable
                                >
                                  <template v-slot:item="{ item, index }">
                                      <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                  </template>
                                  <template v-slot:selection="{ item, index }">
                                      <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                  </template>
                                </v-select>

                              </v-flex>

                            </v-layout>

                          </v-flex>

                          <v-flex shrink v-if="field.fields" v-for="(sfield, name) in field.fields" :key="'main_s_'+ name" pa-0>

                            <v-flex shrink v-if="field.place == 'main' && (sfield.type == 'select' || sfield.type == 'select_enum')" pl-1 pb-1>

                              <v-layout shrink>

                                <v-flex xs5 shrink px-0 pb-2>
                                        
                                  <v-text-field
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    readonly
                                    disabled
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :label="$t(name)"
                                    :rows="1"
                                    color="grey"
                                  >

                                  </v-text-field>

                                </v-flex>

                                <v-flex xs7 shrink px-0 pb-2>

                                  <v-select
                                    :data-testid="$options.name + '__select__' + field.name + sfield.name"
                                    v-model="model.obj[field.name][sfield.name]"
                                    light
                                    :items="getItems[sfield.cls]"
                                    :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                    :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                    single-line
                                    hide-details
                                    flat
                                    class="white"
                                    background-color="white"
                                    clearable
                                  >
                                    <template v-slot:item="{ item, index }">
                                        <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                    </template>
                                    <template v-slot:selection="{ item, index }">
                                        <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                    </template>
                                  </v-select>

                                </v-flex>

                              </v-layout>

                            </v-flex>

                          </v-flex>

                        </v-flex>

                      </v-layout>

                      <v-layout column fill-height v-if="getPlaces[panel] == 'config'" ma-0>

                        <v-flex v-if="getFields && model.bridges" v-for="(field, name) in getFields" :key="'config_'+ name" pa-0>

                          <v-flex shrink v-show="!field.fields && field.show == 'true' && !field.group && (field.type == 'select' || field.type == 'select_enum') && field.place == 'config'" pl-1 pb-1 >

                          </v-flex>

                          <v-flex shrink v-if="field.fields" v-for="(sfield, name) in field.fields" :key="'config_s_'+ name" pa-0>

                            <v-flex shrink v-if="field.place == 'main' && (sfield.type == 'select' || sfield.type == 'select_enum')" pl-1 pb-1>
                              
                              <v-layout shrink>

                                <v-flex xs5 shrink px-0 pb-2>
                                        
                                  <v-text-field
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    readonly
                                    disabled
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :label="$t(name)"
                                    :rows="1"
                                    color="grey"
                                  >

                                  </v-text-field>

                                </v-flex>

                                <v-flex xs7 shrink px-0 pb-2>

                                  <v-select
                                    :data-testid="$options.name + '__select__' + field.name + sfield.name"
                                    v-model="model.obj[field.name][sfield.name]"
                                    light
                                    :items="getItems[sfield.cls]"
                                    :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                    :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                    single-line
                                    hide-details
                                    flat
                                    class="white"
                                    background-color="white"
                                    clearable
                                  >
                                    <template v-slot:item="{ item, index }">
                                        <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                    </template>
                                    <template v-slot:selection="{ item, index }">
                                        <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                    </template>
                                  </v-select>

                                </v-flex>

                              </v-layout>

                            </v-flex>

                          </v-flex>

                        </v-flex>

                      </v-layout>

                      <v-layout column fill-height v-if="getPlaces[panel] == 'config'" py-0>

                          <v-flex v-for="(field, name) in getFields" :key="'other' + name">

                            <v-flex shrink v-if="field.show == 'true' && !field.group && field.place == 'config' && (field.type == 'text' || field.type == 'integer')" px-0 >

                              <v-layout shrink px-2>

                                <v-flex xs5 shrink px-0 pb-2>
                                  
                                  <v-text-field
                                    light
                                    auto-grow
                                    single-line
                                    flat
                                    readonly
                                    disabled
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :label="model.fields[field.name] && model.fields[field.name].required ? $t(field.name) + ' *' : $t(field.name)"
                                    :rows="1"
                                    color="grey"
                                  >

                                  </v-text-field>

                                </v-flex>

                                <v-flex xs7 shrink px-0 pb-2>
                                        
                                  <v-text-field
                                    v-if="field.type == 'integer'"
                                    :data-testid="$options.name + '__text-field__' + field.name"
                                    v-model="model.obj[field.name]"
                                    :type="'number'"
                                    light
                                    auto-grow
                                    :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                    single-line
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >

                                  </v-text-field>
                                  <v-text-field
                                    v-else
                                    :data-testid="$options.name + '__text-field__' + field.name"
                                    v-model="model.obj[field.name]"
                                    light
                                    auto-grow
                                    :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                    single-line
                                    flat
                                    class="white"
                                    persistent-hint
                                    hide-details
                                    :rows="1"
                                    color="accent"
                                  >

                                  </v-text-field>

                                </v-flex>

                                </v-layout>

                            </v-flex>

                          </v-flex>

                          <v-flex xs12 v-if="field.place == 'config'" v-for="(field, name) in getFields" :key="'ping_boolean_' + name" pl-2>

                            <v-checkbox
                              small
                              light
                              color="secondary"
                              height="22"
                              v-if="field.show == 'true' && !field.group && field.type == 'boolean'"
                              :data-testid="$options.name + '__checkbox__' + field.name"
                              v-model="model.obj[field.name]"
                            >
                              <template v-slot:label>
                                <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                                <span class="black--text" v-else>{{$t(field.name)}}</span>
                              </template>
                            </v-checkbox>

                          </v-flex>

                      </v-layout>

                    </v-flex>

                  </v-layout>

                  <v-layout v-if="getPlaces[panel] == 'params' && getSelected.$id" fill-height ma-0>

                    <equipment-measures :nodes="getNodes" :data="getSelected" editable/>

                  </v-layout>

                  <v-layout v-if="getPlaces[panel] == 'settings'" fill-height ma-0>

                    <location-settings
                      :data="getData"
                      @access="(payload) => {onAccessChanged(payload)}"
                      @accessDetails="(payload) => {onAccessDetailsChanged(payload)}"
                    />

                  </v-layout>

                </v-layout>

              </v-container>

          </v-layout>

        </v-form>

    </template>

    <template slot="footer">

    </template>

  </scroll-area>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import EquipmentMeasures from '@/nms/components/equipment/equipment-measures.vue'
import LocationSettings from '@/nms/pages/location/location-settings.vue'
import JsonViewer from 'vue-json-viewer'

// Типы
interface RuleItem {
  community: string
  user: string
  level: string
  authprotocol: string
  authkey: string
  privprotocol: string
  privkey: string
}

interface RulesVer3 {
  [key: string]: RuleItem
}

interface RulesSnmp {
  noVer: RuleItem
  ver1: RuleItem
  ver3: RulesVer3
}

interface RulesData {
  snmp: RulesSnmp
}

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  items?: Record<string, any>
  bridges?: Record<string, any>
  template?: any
  refs?: Record<string, { cls?: string; id?: string }>
  links?: any[]
  measures?: Record<string, any>
  [key: string]: any
}

interface MetaData {
  refs?: any[]
  fields?: Array<{ name: string; [key: string]: any }>
  [key: string]: any
}

interface FormData {
  id: string
  valid: boolean
}

interface DeviceData {
  $id?: string
  id?: string
  cls?: string
  template?: string
  snmp?: {
    version?: number
    level?: string
    [key: string]: any
  }
  height?: number
  position?: number
  [key: string]: any
}

interface CurrentData {
  [key: string]: any
}

interface CabinetData {
  usize?: number
  [key: string]: any
}

interface ClosedUnit {
  position: number
  [key: string]: any
}

interface TemplateData {
  [key: string]: any
}

interface OptionItem {
  [key: string]: boolean
}

interface ValidationResult {
  $id?: string
  valid: any
}

export default Vue.extend({
  name: 'FORM_DEVICE_BAR_FIELDS',

  components: {
    scrollArea,
    datePicker,
    EquipmentMeasures,
    LocationSettings,
    JsonViewer
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
    current: {
      type: Object as () => CurrentData,
      default: () => ({})
    },
    defaultEntity: {
      type: Object as () => any,
      default: () => ({})
    },
    type: {
      type: String,
      default: () => null
    },
    cabinet: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => ClosedUnit[],
      default: () => []
    },
  },

  data(): {
    form: FormData
    panel: number
    exPanel: any | null
    showRefs: boolean
    meta: MetaData | null
    model: ModelData
    measures: any[]
    selected: any | null
    rules: RulesData
    currentSnmpVer: number | null
    currentSnmpLevel: string | null
  } {
    return {
      form: { id: 'form_', valid: false },
      panel: 0,
      exPanel: null,
      showRefs: false,
      meta: null,
      model: {},
      measures: [],
      selected: null,
      currentSnmpVer: null,
      currentSnmpLevel: null,
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getSelected(): any {
      const selectedItem = this.$store.state.devices.selectedItem
      return selectedItem || this.$store.state.devices.activeDevice
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getItems(): Record<string, any> | undefined {
      return this.model.items
    },

    getNodes(): any[] | undefined {
      return this.model.links
    },

    getBridges(): string[] {
      return this.model.bridges ? Object.keys(this.model.bridges) : []
    },

    getPlaces(): string[] {
      let places = this.$store.getters.getPlaces.update.device || []
      if (!this.getData.$id) {
        places = places.filter((place: string) => place !== 'params')
      }
      if (this.getData.cls === 'module') {
        places = places.filter((place: string) => place !== 'settings')
      }
      return places
    },

    getOpenUnits(): (number | { text: string; value: string })[] {
      let deviceSize = 1
      if (this.data.height && this.data.height > 45) {
        deviceSize = Math.ceil(this.data.height / 45)
      }

      const deviceUnits: number[] = []
      const position = this.data.position || 0
      for (let i = position; i > position - deviceSize; i--) {
        deviceUnits.push(i)
      }

      const openUnits: number[] = []
      const cabinetSize = this.cabinet.usize || 0
      for (let i = 0; i < cabinetSize; i++) {
        if (!this.closedUnits.some(unit => unit.position === i + 1) || deviceUnits.includes(i + 1)) {
          openUnits.push(i + 1)
        }
      }

      const acceptUnits: (number | { text: string; value: string })[] = []
      openUnits.forEach(unit => {
        let accept = true
        for (let i = unit; i > unit - deviceSize; i--) {
          if (!openUnits.includes(i)) {
            accept = false
          }
        }
        if (accept) {
          acceptUnits.push(unit)
        }
      })
      acceptUnits.push({ text: 'Вне стойки', value: 'out' })
      return acceptUnits
    },
  },

  watch: {
    data: {
      handler(): void {
        this.$emit('close')
        this.setup('WATCH data')
      },
      deep: true
    },
    model: {
      handler(): void {
        if (!this.model) return
        const ver = this.model.obj?.snmp?.version || null
        const level = this.model.obj?.snmp?.level || null
        if (this.currentSnmpVer !== ver) {
          this.currentSnmpVer = ver
          this.checkSnmpVersion()
        }
        if (this.currentSnmpLevel !== level) {
          this.currentSnmpLevel = level
          this.checkSnmpVersion()
        }
      },
      deep: true
    },
    '$store.state.subscribe.measure': {
      handler(newVal: Record<string, any>): void {
        if (Object.keys(newVal).length) {
          this.$set(this.model, 'measures', {})
          Object.keys(newVal).forEach(key => {
            if (newVal[key]?.measure_id && newVal[key]?.mirror?.value) {
              this.model.measures[newVal[key].measure_id] = newVal[key].mirror.value
            }
          })
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    setup(caller: string): void {
      console.log(this.$options.name, 'setup', 'caller', caller)
      this.showRefs = false
      this.loadMeta()
    },

    async loadMeta(): Promise<void> {
      let type: string
      if (this.type) {
        type = this.type
      } else {
        type = this.getData.cls || 'device'
      }

      const temp = this.getData.$id ? this.getData.template : this.getData.id

      console.log(this.$options.name, 'loadMeta', 'type', type)
      console.log(this.$options.name, 'loadMeta', 'temp', temp)

      try {
        this.setLoader('loadMeta', true)
        const templates = await this.$bridge.getTemplates(type, { id: temp }) as TemplateData[]
        this.meta = await this.$loadMeta(type, temp, this.$options.name)

        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.$set(this.model, 'template', templates[0])

          if (this.getData.$id) {
            this.loadMeasures()
            this.loadLinks()
          }
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadMeta', err)
        this.setLoader('loadMeta', false)
      }
    },

    async loadLinks(): Promise<void> {
      this.model.links = []
      this.setLoader('loadLinks', true)

      const query = {
        id: [this.getData.$id],
        notNull: true,
        data: {
          links: {
            flatten: false,
            data: { brefs: true }
          }
        }
      }
      const obj = await this.$bridge.cmdbQuery(query) as any[]

      if (obj?.[0]) {
        obj[0].children = obj[0].links
        this.$set(this.model, 'links', obj)
      }
      this.setLoader('loadLinks', false)
    },

    async loadMeasures(): Promise<void> {
      this.measures = []
      const meta = await this.$bridge.getMeta('measure') as MetaData
      const optionsField = meta.fields?.find(field => field.name === 'options')
      const options: OptionItem = {}

      if (optionsField?.descriptor) {
        Object.keys(optionsField.descriptor).forEach(key => {
          options[key] = false
        })
      }

      this.setLoader('loadMeasures', true)
      const objId = this.selected || this.data.$id

      if (objId) {
        try {
          const obj = await this.$bridge.getObjectById(objId)
          const measures = await obj.getMeasures(true, false) as any[]

          if (measures) {
            this.measures = measures.map((measure, i) => {
              if (!measure.options || Array.isArray(measure.options)) {
                measure.options = this.$merge({}, options)
              } else if (Object.keys(measure.options).length < 1) {
                measure.options = this.$merge({}, options)
              }
              return measure
            })
          }
        } catch (err) {
          console.error(this.$options.name, 'loadMeasures', 'error', err)
        }
      }

      console.log(this.$options.name, 'loadMeasures', 'this.measures', this.measures)
      this.setLoader('loadMeasures', false)
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model

        if (this.getData.$id) {
          this.$set(this.model.fields, '$id', this.getData.$id)
        }
        this.checkSnmpVersion()
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    onAccessChanged(payload: string): void {
      this.$set(this.model.obj, 'access', JSON.parse(payload))
    },

    onAccessDetailsChanged(payload: string): void {
      this.$set(this.model.obj, 'access_details', JSON.parse(payload))
    },

    validateForm(): ValidationResult {
      const formRef = this.$refs['device-form'] as any
      const v = formRef?.validate() ?? false
      console.log(this.$options.name, 'validateForm', 'v', v)

      const obj: Record<string, any> = {}
      Object.keys(this.model.obj || {}).forEach(key => {
        obj[key] = this.model.obj[key]
      })

      if (this.meta?.refs?.length) {
        const refs: Array<{ ref: string; cls?: string; id?: string }> = []
        Object.keys(this.model.refs || {}).forEach(ref => {
          const refItem = this.model.refs?.[ref]
          if (refItem) {
            refs.push({
              ref: ref,
              cls: refItem.cls,
              id: refItem.id
            })
          }
        })
        obj.refs = refs
      }

      return v ? { $id: this.data.$id, valid: obj } : { $id: this.data.$id, valid: v }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    checkSnmpVersion(): void {
      const version = this.model.obj?.snmp?.version || this.data.snmp?.version

      if (version) {
        this.setLoader('checkSnmpVersion', true)

        if (version === 1 || version === 2) {
          for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.ver1)) {
            if (this.model.fields?.snmp?.fields[name]) {
              this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.ver1[name as keyof RuleItem])
            }
          }
        }

        if (version === 3) {
          const level = this.model.obj?.snmp?.level || this.data.snmp?.level
          const ruleSet = level ? this.$store.getters.getDeviceNails.update.rules.snmp.ver3[level] : this.$store.getters.getDeviceNails.update.rules.snmp.ver3['no auth, no privacy']

          if (ruleSet) {
            for (const name of Object.keys(ruleSet)) {
              if (this.model.fields?.snmp?.fields[name]) {
                this.$set(this.model.fields.snmp.fields[name], 'show', ruleSet[name as keyof RuleItem])
              }
            }
          }
        }
        this.setLoader('checkSnmpVersion', false)
      } else {
        this.setLoader('checkSnmpVersion', true)
        for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.noVer)) {
          if (this.model.fields?.snmp?.fields[name]) {
            this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.noVer[name as keyof RuleItem])
          }
        }
        this.setLoader('checkSnmpVersion', false)
      }
      this.setLoader('checkSnmpVersion', false)
    },

    exPanelClick(e: any): void {
      console.log(this.$options.name, 'exPanelClick', e)
      this.exPanel = this.exPanel === e ? null : e
    },
  },
})
</script>

<style lang="css" scoped>
.params_links {
  /* outline: solid 1px red; */
  border-bottom: solid 1px #1e4972;
}
</style>
